// @ts-nocheck
import { atom } from 'recoil';

export const currentOrganisationDetails = atom<any>({
  key: "currentOrganisationDetails",
});
